module.exports = __webpack_public_path__ + "img/balance_ico1.e0085ab3.png";